
        var result = require("!!../../../../node_modules/css-loader/index.js!./cases-management-dashboard.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/cases-management-dashboard/cases-management-dashboard.component.css
// module id = 609
// module chunks = 0